import CryptoJS from "crypto-js";

// Secret key for encryption and decryption
const secretKey = "WW-2024-SECURE-ENCRYPTION-KEY-V1";

// Encrypt data
export const encryptData = (data) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
};

// Decrypt data
// export const decryptData = (data) => {
//   if (!data) {
//     console.warn("Decryption error: Data is null or undefined!");
//     return;
//   }

//   const bytes = CryptoJS.AES.decrypt(data, secretKey);
//   const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
//   return JSON.parse(decryptedData);
// };
export const decryptData = (data) => {
  if (!data) {
    console.warn("Decryption error: Data is null, undefined, or empty!");
    return null;  // Return null instead of attempting decryption
  }

  try {
    const bytes = CryptoJS.AES.decrypt(data, secretKey);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

    if (!decryptedData) {
      console.warn("Decryption error: Decrypted data is empty!");
      return null;
    }

    return JSON.parse(decryptedData);
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};